import React from 'react'

import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import PlaceLevelsLoader from './_load/PlaceLevelsLoader'
import PlaceLevelsTable from './table/PlaceLevelsTable'

const PageContent = () => {
  return (
    <>
      <MultiSelectHandler>
        <PlaceLevelsLoader uncontrolledChildren={<MultiRowsActions />}>
          <PlaceLevelsTable />
        </PlaceLevelsLoader>
      </MultiSelectHandler>
    </>
  )
}

export default PageContent
